import { render } from "./FooterBlock.vue?vue&type=template&id=3398a010&scoped=true"
const script = {}

import "./FooterBlock.vue?vue&type=style&index=0&id=3398a010&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3398a010"]])

export default __exports__